
import Vue from "vue"
import ListParagon from '@/components/ListParagon.vue'
import dateFormatMixin from '@/mixins/DateFormatMixin.vue'

export default Vue.extend({
  name: 'SpaceList',
  components: {
    ListParagon,
  },
  mixins: [
    dateFormatMixin
  ],
  data () {
    return {
      headers: [
        {
          text: this.$vuetify.lang.t("$vuetify.id"),
          sortable: false,
          value: 'id',

          width: '200px'
        },
        {
          text: this.$vuetify.lang.t("$vuetify.company_name"),
          sortable: false,
          value: 'name',
        },
        {
          text: this.$vuetify.lang.t("$vuetify.deleted_at"),
          sortable: false,
          value: 'deleted_at'
        }
      ],
      headersSplitPane: [
        {
          text: this.$vuetify.lang.t("$vuetify.id"),
          sortable: false,
          value: 'id'
        },
        {
          text: this.$vuetify.lang.t("$vuetify.company_name"),
          sortable: false,
          value: 'name'
        }
      ],
      filters: [
        { label: 'name', type: 'text-field', text: this.$vuetify.lang.t("$vuetify.company_name") }
      ],
      url: "/v1/admin/spaces"
    }
  }
})
